export enum LimitSteps {
	NONE = "none",
	INCREASE_LIMIT = "increaseLimit",
	CREDIT_RATING = "creditRating",
	PARTIAL_DEPOSIT_AFTER_LIMIT_INCREASE = "partialDepositAfterLimitIncrease",
}
